
import { Dictionary } from 'src/app/core/model/dictionary';
import { FacilityEdit } from 'src/app/facility/model/facility-edit';
import { Address } from 'src/app/member/model/member';

export class ProviderEdit
{
    public id = null;
    public version = 0;
    public firstName = '';
    public lastName = '';
    public middleName = '';
    public npi = '';
    public genderId: number;
    public gender = '';
    public genderName = '';
    public professionalSuffix = '';
    public suffix = '';
    public title = '';
    public directAddress = '';
    public organization = '';
    public specialtyId: number;
    public specialty = '';
    public specialtyName = '';
    public qualityScore: number;
    public practiceAddress: Address;
    public cellPhoneNumber = '';
    public telephoneNumber = '';
    public telephoneNumberExtension = '';
    public faxNumber = '';
    public email = '';
    public distance: number;
    public languages: Dictionary[] = [];
    public facilities: FacilityEdit[] = [];
    public streetLine: string;
    public streetLineAdditional: string;
    public city: string;
    public county: string;
    public postalCode: string;
    public state: Dictionary;
    public country: Dictionary;
    public url = '';
    public description = '';
}
